import {
  AdConfigurationAreaDataTestIds,
  AdConfigurationAreaRoutes,
} from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { ImageIcon } from '@moia-dev/pace-icons'

export const AdConfigurationAreaNavigationIcon = ImageIcon

export const AdConfigurationAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={AdConfigurationAreaRoutes.route}
      Icon={ImageIcon}
      dataTestId={AdConfigurationAreaDataTestIds.Navigation}
    />
  )
}
